import { render, staticRenderFns } from "./ArpIntegradaDetail.vue?vue&type=template&id=5d082882&scoped=true&"
import script from "./ArpIntegradaDetail.vue?vue&type=script&lang=js&"
export * from "./ArpIntegradaDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArpIntegradaDetail.vue?vue&type=style&index=0&id=5d082882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d082882",
  null
  
)

export default component.exports